<template>
    <div>
        <v-container fluid grid-list-xl class="home-container general-container">
            <v-layout row wrap class="navigation-header">
                <v-flex xs12>
                    <header-bar></header-bar>
                </v-flex>
            </v-layout>

            <div class="scrolling-content-products padding-left-xxl padding-right-xxl">
                <v-layout row wrap class="page-content">
                    <v-flex md12 xs12 align-start class="no-padding-bottom">
                        <h2 class="page-title">{{text('db.global.TYPE_GTS_WELCOME_TITLE_D')}}</h2>
                        <div class="margin-bottom-m">
                            <span class="margin-right-xxs">
                                I am Doctor SMASS, here to guide you.<br />
                                Please select how you want to continue
                            </span>
                        </div>
                    </v-flex>
                    <v-flex md12 xs12 align-end class="activate-product">
                        <v-btn color="primary" @click="chooseAssessmentModeStandard()" class="text-uppercase font-weight-light" >Standard</v-btn>
                        <br />
                        <v-btn color="primary" @click="chooseAssessmentModeChatBot()" class="text-uppercase font-weight-light" >Chat bot</v-btn>
                    </v-flex>
                </v-layout>


            </div>
        </v-container>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import {mapActions, mapGetters} from 'vuex';
    import HeaderBar from '../shared/HeaderBar';

    export default {
        name: 'WelcomePage',
        components: {
            HeaderBar,
        },

        beforeCreate() {
            // Reset stores.
            this.$store.commit('ProductListStore/resetStore');
            this.$store.commit('AssessmentStartStore/resetStore');
            this.$store.commit('ChooseMainSymptomStore/resetStore');
            this.$store.commit('SymptomsQuestionsStore/resetStore');
            this.$store.commit('EvaluationStore/resetStore');
            this.$store.commit('ScoringStore/resetStore');
            this.$store.commit('SummaryStore/resetStore');
            this.$store.commit('AssessmentAlertsStore/resetStore');
        },

        computed: {
            ...mapGetters({
                getUserData: 'UserStore/getUserData',
                getAppTypes: 'UserStore/getAppTypes'
            }),
        },

        methods: {
            ...mapActions({
                showActivationCodePopup: 'ProductListStore/showActivationCodePopup'
            }),

            // ----- Component methods: -----

            chooseAssessmentModeStandard() {
                this.$store.dispatch("UserStore/submitCurrentAppType", this.getAppTypes.PF).then(() => {
                    this.$router.push({name: 'PF_HomePage'}); // Go to Product List page.
                });
            },
            chooseAssessmentModeChatBot() {
                this.$store.dispatch("UserStore/submitCurrentAppType", this.getAppTypes.PF_CHATBOT).then(() => {
                    this.$router.push({name: 'PF_ChatBotPage'}); // Go to ChatBot page.
                });
            },
        },

        data () {
            return {
                items: [
                    {
                        src: 'static/img/in4medicine_logo.svg',
                        title: 'in4medicine',
                        description: 'Medizin und Informatik - ein starkes Team.'
                    }
                ]
            }
        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pathfinder/components/welcome/WelcomePage.vue